﻿import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';

//TODO [Pedro]: Este módulo está pendiente de la maquetación correcta para reescribir ciertas partes, tambien hay que ver si se debe
//tocar el html que devuelve el ASP por AJAX
class Publicidad {
    
    constructor(publicidadDTO){
        this.publicidadDTO = publicidadDTO;
        this.bar = jquery('.cajonalertafooter');
        this.$finsblr = jquery('.finsblr');
        this.$sblr1 = jquery('#js-sblr1');
        this.$sblr2 = jquery('#js-sblr2');
        this.__loadPublicidad();
        

    }

    __loadPublicidad(){
        //TODO [Pedro] revisar en el ASP si es necesario pasar los parámetros del formulario además del parámetro P
        jquery.ajax({
            url: this.publicidadDTO.urlPublicidad,
            type: 'POST',
            data: 'p=' + this.publicidadDTO.dataPublicidad,
            dataType: 'html',
            success: (data) => {
                this.__mostrarPublicidad(data);
                this.__posicionarBar();
            },
                
            error:  (jqXHR, textStatus, errorThrown) => {
                this.__ocultarSBLR1();
                this.__ocultarSBLR2();
                const msg = `Error MostrarPublicidad carga en segundo plano: responseText: ${jqXHR.responseText} textStatus: ${textStatus} errorThrown: ${errorThrown}`;
                throw msg;
            }
        });
    }


    __posicionarBar(){
        if (this.$finsblr.length > 0){

            const offset = this.$finsblr.offset();

            if (offset !== undefined){
                const top = offset.top;
                this.bar.css({ 'top': top, 'position' : 'absolute' });
            }
        }
    }

    __mostrarPublicidad(data){
        const sblrArray = data.split('<separador/>');

        if (sblrArray[0] && sblrArray[0].length > 0) {
            this.$sblr1.html(sblrArray[0]);
            this.__ocultarAlertas();
        }
        else {
            this.__ocultarSBLR1();
        }

        if (sblrArray[1] && sblrArray[1].length > 0) {
            this.$sblr2.html(sblrArray[1]);
        }
        else {
            this.__ocultarSBLR2();
        }
        
        this.__loadImagesPublicidad();
        jquery.publish(HabEvents.EventsEnum.LogosCargados);
        
        // jquery.publish(HabitacliaGlobal.UIEvents.EventsEnum.FiltrosListadoExpandidos);
    }

    __ocultarAlertas(){
        setTimeout(function () {
            const listainmueblesleftHeight = jquery('.listainmueblesleft').height();
            const filtrosHeight = jquery('.filtros').height();
            const cajanalertaFooterHeight = jquery('.cajonalertafooter').height();
            const alertarsHeaderNHeight = (jquery('#alertaslistaheaderN').length > 0 ? jquery('#alertaslistaheaderN').height() : 0);
            const sblrHeight = (jquery('.sblr1').length > 0 ? jquery('.sblr1').height() : 0);
            const $cajonAlertaFooter = jquery('.cajonalertafooter');

            if (listainmueblesleftHeight < filtrosHeight + cajanalertaFooterHeight + alertarsHeaderNHeight + sblrHeight) {
                $cajonAlertaFooter.removeClass('mostrar').addClass('ocultar');
            } else {
                $cajonAlertaFooter.removeClass('ocultar').addClass('mostrar');
            }

        }, 3000);
    }

    __ocultarSBLR1() {
        jquery('.sblr.sblr1').remove();
    }

    __ocultarSBLR2(){
        jquery('.sblr.sblr2').remove();
    }

    __loadImagesPublicidad() {
        jquery('#js-sblr1 .loadImg').each((index, element) => {
            if (element.name.length > 0) {
                element.src = element.name;
                element.name = '';
            }
        });

        jquery('#js-sblr2 .loadImg').each((index, element) => {
            if (element.name.length > 0) {
                element.src = element.name;
                element.name = '';
            }
        });
    }

}

export default Publicidad;
